/* 🤖 this file was generated by svg-to-ts */
export const matIconDirections: {
  name: 'directions';
  data: string;
} = {
  name: 'directions',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m22.43 10.59-9.01-9.01c-.75-.75-2.07-.76-2.83 0l-9 9c-.78.78-.78 2.04 0 2.82l9 9c.39.39.9.58 1.41.58.51 0 1.02-.19 1.41-.58l8.99-8.99c.79-.76.8-2.02.03-2.82zm-10.42 10.4-9-9 9-9 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z"/></svg>`
};
